import React from 'react';
import { Helmet } from 'react-helmet-async';

const About = () => {
    return (
        <div>
            <Helmet>
                <title>About - Genius Car Service</title>
            </Helmet>
            <h2>This is About us</h2>
        </div>
    );
};

export default About;